import {
  Action,
  ActionType,
  IInformationSettingResponse,
} from "models/setting/general";
import createReducer from "redux/createReducer";

export interface SettingInformationReducerType {
  loading: boolean;
  error?: string;
  settingInformationResponse?: IInformationSettingResponse;
}

const defaultState: SettingInformationReducerType = {
  loading: false,
  error: undefined,
  settingInformationResponse: undefined,
};

export const settingInformationReducer =
  createReducer<SettingInformationReducerType>(defaultState, {
    [ActionType.INFORMATION_SETTING](state: SettingInformationReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.INFORMATION_SETTING_ERROR](
      state: SettingInformationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.INFORMATION_SETTING_SUCCESS](
      state: SettingInformationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        settingInformationResponse: action.payload,
      };
    },

    [ActionType.INFORMATION_SETTING_RESET](
      state: SettingInformationReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        settingInformationResponse: undefined,
      };
    },
  });
